import { normName } from '~shared/lib/normalize';
import type { QueryToken } from './types';

function splitTokens(input: string): string[] {
  const out: string[] = [];
  let cur = '';
  let depth = 0;
  for (const ch of input) {
    if (ch === '(') depth++;
    else if (ch === ')') depth = Math.max(0, depth - 1);
    else if (depth === 0 && (ch === ',' || ch === '\n' || ch === ';')) {
      out.push(cur);
      cur = '';
      continue;
    }
    cur += ch;
  }
  out.push(cur);
  return out;
}

const PARENTHETICAL = /\(([^)]*)\)/g;
const LEADING_MARKER = /^[\s\-–—•*·]+/;
const LEADING_NUMBER = /^\d+\s*[.)]?\s+/;
const QUOTES = /["“”„]/g;

function stripMarkers(s: string): string {
  let out = s.replace(LEADING_MARKER, '');
  const renumbered = out.replace(LEADING_NUMBER, '');
  if (renumbered.trim()) out = renumbered;
  return out.replace(LEADING_MARKER, '');
}

export function parseNames(input: string): QueryToken[] {
  const seen = new Set<string>();
  const out: QueryToken[] = [];

  for (const raw of splitTokens(input)) {
    const notes: string[] = [];
    const withoutNotes = raw.replace(PARENTHETICAL, (_m, inner: string) => {
      const t = inner.trim();
      if (t) notes.push(t);
      return ' ';
    });

    const name = stripMarkers(withoutNotes.replace(QUOTES, ' '))
      .replace(/\s+/g, ' ')
      .trim();
    if (!name) continue;

    const key = normName(name);
    if (!key || seen.has(key)) continue;
    seen.add(key);

    out.push({ raw: raw.trim(), name, note: notes.join(', ') });
  }

  return out;
}
